import { offsetLabel, timezoneAbbreviation } from "@visioni/a3s-monitoring/app";

/** What every Patriot tools field shows when it has no value. */
export const EMPTY = "—";

const DATE_TIME: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

/**
 * An activation instant with seconds and its zone — support compares these
 * against Patriot's own screens and device logs, so the zone has to be on the
 * page rather than assumed.
 *
 * In `timeZone` where a list is filtered in one, so the rows read in the same
 * wall clock as the range that chose them, named as the timezone picker names
 * it: `AEDT` where the zone has an abbreviation, else its offset (`UTC+8`).
 * Otherwise in the viewer's own zone, with its offset.
 */
export function formatInstant(iso: string | undefined, timeZone?: string): string {
  if (iso === undefined || iso === "") return EMPTY;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  if (timeZone === undefined) return date.toLocaleString("en-AU", { ...DATE_TIME, timeZoneName: "shortOffset" });
  const zone = timezoneAbbreviation(timeZone, date) ?? offsetLabel(timeZone, date);
  const local = date.toLocaleString("en-AU", { ...DATE_TIME, timeZone });
  return zone === undefined ? local : `${local} ${zone}`;
}

/**
 * Whether a Patriot text field has anything to show. The API keeps an empty
 * field as `""` rather than dropping it, so present is not the same as shown.
 */
export function hasText(text: string | undefined): text is string {
  return text !== undefined && text !== "";
}

/** A Patriot text field for display, or `EMPTY` when it has nothing to show. */
export function formatText(text: string | undefined): string {
  return hasText(text) ? text : EMPTY;
}
